<div
  class="palette w-full flex items-center justify-center border-a-12"
  [class.editable]="allowEdit"
>
  @for (color of colors; track trackByIndexFn(i, color); let i = $index) {
    <blaze-color-picker
      class="color rectangle"
      [disabled]="!allowEdit"
      [color]="color"
      (colorChange)="onColorChange($event, i)"
    />
  }
</div>
